import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { DeleteOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';

const Training = ({ training, index, removeTraining, openAddModal, columnId, isDragDisabled = false, isDragging = false }) => {
  return (
    <Draggable draggableId={training.id} index={index} isDragDisabled={false}>
      {(provided, snapshot) => {
        const containerClass = classNames('card-container', {
          dragging: snapshot.isDragging,
          disabled: snapshot.isDropDisabled,
        });

        return (
          <div className={containerClass} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
            <div className="card">
              <div className="rightBtn">
                <Tooltip title={columnId === 'available' ? 'Permanently remove' : 'Move back to the training list'}>
                  <span
                    onClick={() =>
                      removeTraining({
                        id: training.id,
                        position: columnId,
                      })
                    }
                  >
                    {columnId === 'available' ? <DeleteOutlined /> : <CloseOutlined />}
                  </span>
                </Tooltip>
              </div>

              <div className="leftBtn">
                <Tooltip title="Edit" placement="top">
                  <span onClick={() => openAddModal(training.id)}>
                    <EditOutlined />
                  </span>
                </Tooltip>
              </div>

              <div className="type">Training</div>
              <div className="title">{training.name}</div>
              <div className="details">
                {training.organizer} | {training.country}
              </div>
            </div>
          </div>
        );
      }}
    </Draggable>
  );
};

export default Training;
